import React from 'react';
import SearchInput from '@/components/SearchInput';
import { searchFilter as SearchFilterIcon } from '@/assets/icons/icons';
import { ChevronDownIcon, ChevronUpIcon } from '@/assets/icons/icons';

interface Props {
  searchQuery: string;
  setSearchQuery: (v: string) => void;
  activeView: boolean;
  totalMatches: number;
  currentMatchNumber?: number;
  handlePrevMatch: () => void;
  handleNextMatch: () => void;
  formatPaste?: boolean;
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: 8,
  } as React.CSSProperties,
  matchNavContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  } as React.CSSProperties,
  matchText: {
    fontSize: 12,
  } as React.CSSProperties,
  navButton: {
    border: 'none',
    background: 'transparent',
    padding: 0,
    width: 28,
    height: 28,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'background 0.15s ease',
    borderRadius: 50,
  } as React.CSSProperties,
};

const SearchWithMatchNavigator: React.FC<Props> = ({
  searchQuery,
  setSearchQuery,
  activeView,
  totalMatches,
  currentMatchNumber,
  handlePrevMatch,
  handleNextMatch,
  formatPaste,
}) => {
  return (
    <div style={styles.container}>
      <SearchInput
        borderWidth='2px'
        placeholder=''
        defaultValue={searchQuery}
        onChange={(val: string) => setSearchQuery(val)}
        onClear={() => setSearchQuery('')}
        style={{
          flex: 1,
          paddingRight: 10,
        }}
        prefixIcon={<SearchFilterIcon width={12} height={12} />}
        formatPaste={formatPaste}
      />

      {activeView && totalMatches > 0 && (
        <div style={styles.matchNavContainer}>
          {typeof currentMatchNumber !== 'undefined' && (
            <span className='zl-para-400-12' style={styles.matchText}>
              {currentMatchNumber} / {totalMatches}
            </span>
          )}

          <button
            type='button'
            onClick={handlePrevMatch}
            disabled={!totalMatches}
            style={styles.navButton}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = 'var(--dark-border)')
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = 'transparent')
            }
          >
            <ChevronUpIcon size={14} color='var(--text-primary)' />
          </button>

          <button
            type='button'
            onClick={handleNextMatch}
            disabled={!totalMatches}
            style={styles.navButton}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = 'var(--dark-border)')
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = 'transparent')
            }
          >
            <ChevronDownIcon size={14} color='var(--text-primary)' />
          </button>
        </div>
      )}
    </div>
  );
};

export default SearchWithMatchNavigator;
